import React from 'react';
import { motion } from 'framer-motion';
import { Archive } from 'lucide-react';

interface BackupActionsToolbarProps {
  loading: boolean;
  selectedBackups: string[];
  backupsCount: number;
  onCreateBackup: () => void;
  onBulkAction: (action: string) => void;
  onRefresh: () => void;
}

const BackupActionsToolbar: React.FC<BackupActionsToolbarProps> = ({
  loading,
  selectedBackups,
  backupsCount,
  onCreateBackup,
  onBulkAction,
  onRefresh,
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          onClick={onCreateBackup}
          disabled={loading}
        >
          <Archive className="w-4 h-4 mr-2 inline" />
          Create Backup
        </motion.button>

        {selectedBackups.length > 0 && (
          <div className="flex items-center space-x-2">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm"
              onClick={() => onBulkAction('download')}
              disabled={loading}
            >
              Download ({selectedBackups.length})
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
              onClick={() => onBulkAction('delete')}
              disabled={loading}
            >
              Delete ({selectedBackups.length})
            </motion.button>
          </div>
        )}
      </div>

      <div className="flex items-center space-x-2">
        <span className="text-sm text-slate-500 dark:text-slate-400">
          {backupsCount} total backups
        </span>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
          onClick={onRefresh}
        >
          ↻
        </motion.button>
      </div>
    </div>
  );
};

export default BackupActionsToolbar;